export default __webpack_public_path__ + "static/media/rtfcover2 copy.75000edb.png";